import styled from 'styled-components';

import { spacing } from '_utils/props';

import { text_m, text_xs } from '_utils/styles';

export const Label = styled.span`
  display: block;
`;

export const Title = styled.span`
  ${text_m}
  margin: 0;

  &.selected {
    font-weight: bold;
  }
`;

export const Count = styled.span`
  ${text_xs}
  margin: 0;
  color: ${({ theme }) => theme.colors.element.quaternary};
`;

export const ShowMoreContainer = styled.div`
  ${({ theme }) => spacing({ theme, $mt: 2 })}
`;

export const Description = styled.span`
  ${text_xs}
  margin: 0;
  display: block;
  color: ${({ theme }) => theme.colors.element.quaternary};
`;
